import $ from 'jquery';
import { API_METHODS } from './api.enums';
// import config from './configuration';

// TODO : remove this file entirely and rename newAPIService to apiService

export const TIMEOUT_ERROR_CODE = 'ECONNABORTED';

const baseAjaxConfig = {
    // dataType: 'json', keep it undefined for inteligent guess
    contentType: 'application/json; charset=utf-8',
    global: true,
    showGlobalError: true,
};

// saves last five calls
export const lastAPICalls = [];

export const updateAPILog = (path, type, body = {}) => {
    lastAPICalls.unshift({
        path,
        type,
        body,
    });
    lastAPICalls.splice(5, 1);
};

export default class ApiService {
    /**
     * @param {string} path
     * @param {Object} config
     * @param {boolean} [config.global]
     * @param {boolean} [config.showGlobalError]
     * @param {string} [config.contentType] The type and charset of the data sending to the server
     * default : application/json; charset=utf-8
     * @param {string} [config.dataType] The type of data accepted from the server
     * default: json
     */
    static async get(path, config) {
        updateAPILog(path, API_METHODS.GET);
        const configuration = { ...baseAjaxConfig, ...config };

        try {
            return await $.ajax({
                url: path,
                type: API_METHODS.GET,
                error: err => err.showGlobalError = configuration.showGlobalError,
                ...configuration,
            });
        } catch (error) {
            if (configuration.showGlobalError !== true) throw error;
            return Promise.resolve();
        }
    }

    /**
     * @param {string} path
     * @param {Object} data
     * @param {Object} config
     * @param {boolean} [config.global]
     * @param {boolean} [config.showGlobalError]
     * @param {string} [config.contentType] The type and charset of the data sending to the server
     * default : application/json; charset=utf-8
     * @param {string} [config.dataType] The type of data accepted from the server
     * default: json
     */
    static async post(path, data, config) {
        updateAPILog(path, API_METHODS.POST, data);

        const configuration = { ...baseAjaxConfig, ...config };
        const { contentType, showGlobalError } = configuration;

        try {
            return await $.ajax({
                url: path,
                type: API_METHODS.POST,
                data: (typeof contentType === 'string') && (contentType.indexOf('json') !== -1) ? JSON.stringify(data) : data,
                error: err => err.showGlobalError = configuration.showGlobalError,
                ...configuration,
            });
        } catch (error) {
            if (showGlobalError !== true) throw error;
            return Promise.resolve();
        }
    }

    /**
     * @param {string} path
     * @param {Object} data
     * @param {Object} config
     * @param {boolean} [config.global]
     * @param {boolean} [config.showGlobalError]
     * @param {string} [config.contentType] The type and charset of the data sending to the server
     * default : application/json; charset=utf-8
     * @param {string} [config.dataType] The type of data accepted from the server
     * default: json
     */
    static async put(path, data, config) {
        updateAPILog(path, API_METHODS.PUT, data);
        const configuration = { ...baseAjaxConfig, ...config };
        const { contentType, showGlobalError } = configuration;

        try {
            return await $.ajax({
                data: (typeof contentType === 'string') && contentType.indexOf('json') ? JSON.stringify(data) : data,
                url: path,
                type: API_METHODS.PUT,
                error: err => err.showGlobalError = configuration.showGlobalError,
                ...configuration,
            });
        } catch (error) {
            if (showGlobalError !== true) throw error;
            return Promise.resolve();
        }
    }

    /**
     * @param {string} path
     * @param {Object} config
     * @param {boolean} [config.global]
     * @param {boolean} [config.showGlobalError]
     * @param {string} [config.contentType] The type and charset of the data sending to the server
     * default : application/json; charset=utf-8
     * @param {string} [config.dataType] The type of data accepted from the server
     * default: json
     */
    static async delete(path, config) {
        updateAPILog(path, API_METHODS.DELETE);
        const configuration = { ...baseAjaxConfig, ...config };

        try {
            return await $.ajax({
                url: path,
                type: API_METHODS.DELETE,
                error: err => err.showGlobalError = configuration.showGlobalError,
                ...configuration,
            });
        } catch (error) {
            if (configuration.showGlobalError !== true) throw error;
            return Promise.resolve();
        }
    }
}
